<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Descrição geral</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            Tive que alterar um programa da empresa onde trabalho. Programa antigo, escrito em Borland C++ Builder 3.
            Interface gráfica antiga, não responsiva. Algumas partes do código faziam cálculos matemáticos para descobrir onde posicionar um campo, dependendo
            do tamanho da tela do usuário. Enfim, um trabaho gigantesco. Mais tempo compilando e testando do que alterando o programa de verdade.
          </v-col>

          <v-col class="col-10 offset-1">
            Imaginando as facilidades que o HTML, o CSS e o Javascript podem fornecer para um programador fazer uma interface gráfica decente, moderna, bonita,
            responsiva, eu pensei: por que não?
          </v-col>

          <v-col class="col-10 offset-1">
            <p>E analisando alternativas, começaram a aparecer os problemas:</p>
          </v-col>

          <v-col class="col-10 offset-2">
            <ul>
              <li>A aplicação acessa hardware conectado ao computador;</li>
              <li>Não posso expor código que possa ser visualizado através das ferramentas do browser;</li>
              <li>É uma aplicação desktop que não pode ser transformada em Web já que nem todos os clientes tem acesso à internet.</li>
            </ul>
          </v-col>

          <v-col
            class="col-10 offset-1"
          >Ao pensar mais no assunto e pesquisar bastante na internet, creio ter descoberto uma solução muito interessante:</v-col>

          <v-col class="col-10 offset-1 text-center">
            <strong>Wails</strong>
          </v-col>

          <v-col class="col-10 offset-1">Para que serve o Wails?</v-col>

          <v-col class="col-10 offset-1">
            É uma ferramenta que "mistura", por assim dizer, HTML, CSS, Javascript e Go em um executável nativo puro, indevassável. Uma aplicação desktop cujo frontend
            é escrito com frameworks para Web (Angular, React ou Vue) e o backend é escrito em Go.
          </v-col>

          <v-col
            class="col-10 offset-1"
          >Nas próximas seções vamos detalhar um pouco mais o que é possível fazer através do uso destas ferramentas.</v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/options">Possibilidades...</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
